import { Container } from "react-bootstrap"

const Footer = () => {
  return (
    <Container className="p-4 clear-player-bar">
      <p>&copy; CDLBT {new Date().getFullYear()}</p>
    </Container>
  )
}
export default Footer
